export function debouncePromise<R, A extends unknown[]>(
  inner: (...args: A) => Promise<R>,
  timeout: number,
) {
  let timer: number;
  let lastResolve: (result: Promise<R>) => void;

  return (...args: A) => {
    if (timer !== undefined) {
      clearTimeout(timer);
    }
    timer = window.setTimeout(() => {
      const result = inner(...args);
      lastResolve(result);
    }, timeout);

    return new Promise<R>((resolve) => {
      lastResolve = resolve;
    });
  };
}
